import { render } from "./Header.vue?vue&type=template&id=70afb0c1&scoped=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=70afb0c1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-70afb0c1"

export default script